import React, { useEffect, useState, useMemo } from 'react';
import { Container, Input, FormGroup, Label } from 'reactstrap';
import AddRegion from './AddRegion';
import UpdateViewRegion from './UpdateViewRegion';
import TableRoot from './tables/TableRoot';
import Shimmer from 'commonComponents/Shimmer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRegionList, fetchRegionById } from './redux/dispatcher';
import useDebouncedEffect from 'commonComponents/DeboucedEffect';

function Index() {
    const dispatch = useDispatch();
    const regionListState = useSelector((state) => state.regionListReducer);

    const [searchQuery, setSearchQuery] = useState('');
    const [isUpdate, setIsUpdate] = useState(false);
    const [isViewOnly, setIsViewOnly] = useState(false);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    const rawData = regionListState?.data;
    // Data array might be in regionListState.data.data or regionListState.data directly
    const regionList = useMemo(() => {
        if (Array.isArray(rawData)) return rawData;
        if (Array.isArray(rawData?.data)) return rawData.data;
        if (Array.isArray(rawData?.payload?.data)) return rawData.payload.data;
        return [];
    }, [rawData]);

    const paginationData = rawData?.pagination || rawData?.payload?.pagination;
    const totalPages = paginationData?.totalPages || 1;

    useEffect(() => {
        dispatch(fetchRegionList({ searchQuery, currentPage, rowsPerPage }));
    }, [dispatch, currentPage, rowsPerPage]);

    useDebouncedEffect(() => {
        dispatch(fetchRegionList({ searchQuery, currentPage, rowsPerPage }));
    }, [searchQuery], 500);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchQuery(value);
        setCurrentPage(1);
    };

    const selectedRegionFromRedux = regionListState?.selectedRegion;

    const handleEdit = (region) => {
        setSelectedRegion(region);
        if (region?.id) {
            dispatch(fetchRegionById(region.id));
        }
        setIsViewOnly(false);
        setIsUpdate(true);
    };

    const handleView = (region) => {
        setSelectedRegion(region);
        if (region?.id) {
            dispatch(fetchRegionById(region.id));
        }
        setIsViewOnly(true);
        setIsUpdate(true);
    };

    const handleCloseUpdateViewModal = () => {
        setIsUpdate(false);
        setIsViewOnly(false);
        setSelectedRegion(null);
    };

    // Client-side search filtering fallback in case API returns unfiltered list
    const filteredTableData = useMemo(() => {
        if (!searchQuery.trim()) return regionList;
        const q = searchQuery.toLowerCase();
        return regionList.filter(
            (item) =>
                item?.name?.toLowerCase().includes(q) ||
                item?.address?.toLowerCase().includes(q)
        );
    }, [regionList, searchQuery]);

    const isShimmer = regionListState?.isLoading && regionList.length === 0;

    return (
        <>
            <div className="col-12 d-flex justify-content-end stickyFilter">
                <Container fluid>
                    <div className="d-flex flex-row justify-content-end mt-4 mb-3">
                        <FormGroup className="mr-3">
                            <Label for="searchInput" hidden>
                                Search
                            </Label>
                            <div style={{ position: 'relative', width: '230px', display: 'inline-block' }}>
                                <Input
                                    type="text"
                                    id="searchInput"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                    placeholder="Search by Name/Address"
                                    style={{ width: '100%', paddingRight: '30px' }}
                                />
                                {searchQuery && (
                                    <i
                                        className="fa-solid fa-xmark"
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer',
                                            color: '#6c757d'
                                        }}
                                        onClick={() => {
                                            setSearchQuery('');
                                            setCurrentPage(1);
                                        }}
                                    ></i>
                                )}
                            </div>
                        </FormGroup>
                        <div>
                            <AddRegion />
                        </div>
                    </div>
                </Container>
            </div>

            <div>
                {isShimmer ? (
                    <Shimmer />
                ) : (
                    <TableRoot
                        header={['Sr. No.', 'Region Name', 'Admin Name', 'Companies', 'Address', 'Creating Time', 'Action']}
                        tableData={filteredTableData}
                        handleEdit={handleEdit}
                        handleView={handleView}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                    />
                )}
            </div>

            {isUpdate && (
                <UpdateViewRegion
                    isOpen={isUpdate}
                    toggleModal={handleCloseUpdateViewModal}
                    isViewOnly={isViewOnly}
                    data={selectedRegionFromRedux?.id === selectedRegion?.id ? selectedRegionFromRedux : (selectedRegionFromRedux || selectedRegion)}
                />
            )}
        </>
    );
}

export default Index;
